import { adsenseProvider } from './adsense'
import { mediavineProvider } from './mediavine'
import { adsConfig } from './../config'
import { _getTestProvider, type AdProvider } from './types'

/** The active ad provider — the scripted test double when injected, else the configured network. */
export function provider(): AdProvider {
  return _getTestProvider() ?? (adsConfig().provider === 'mediavine' ? mediavineProvider : adsenseProvider)
}
